import { render } from "./SidebarAdminComponent.vue?vue&type=template&id=32a1f262&scoped=true"
import script from "./SidebarAdminComponent.vue?vue&type=script&lang=js"
export * from "./SidebarAdminComponent.vue?vue&type=script&lang=js"

import "./SidebarAdminComponent.vue?vue&type=style&index=0&id=32a1f262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a1f262"]])

export default __exports__